import React from 'react';

const ButtonBlock = ({onChange, value}) => {
  const addButton = () => {
    const data = value.data || {};
    if (!data.buttons) {
      data.buttons = 2;
    } else if (data.buttons < 3) {
      data.buttons += 1;
    }

    onChange({
      data: data
    });
  };
  const removeButton = (i) => {
    const data = value.data || {};
    if (i === 2) {
      delete data.button2;
      data.buttons = 2;
    } else if (i === 1) {
      delete data.button1;
      data.buttons = 1;
      if (data.button2) {
        data.buttons = 2;
        data.button1 = data.button2;
        delete data.button2;
      }
    } else if (i === 0) {
      data.buttons = 1;
      delete data.button0;
      if (data.button1) {
        data.button0 = data.button1;
        delete data.button1;
      }
      if (data.button2) {
        data.buttons = 2;
        data.button1 = data.button2;
        delete data.button2;
      }
    }

    onChange({
      data: data
    });
  };

  const toggleBlank = (i, enabled) => {
    const data = value.data || {};
    if (!data[[`button${i}`]]) {
      return;
    }

    if (enabled) {
      data[[`button${i}`]].blank = enabled;
    } else {
      delete data[[`button${i}`]].blank;
    }
    onChange({
      data: data
    });
  };

  const changeButtonType = (i, type) => {
    const data = value.data || {};
    if (!data[[`button${i}`]]) {
      data[[`button${i}`]] = {};
    }

    data[[`button${i}`]].type = type;
    onChange({
      data: data
    });
  };

  const changeText = (i, text) => {
    const data = value.data || {};
    if (!data[[`button${i}`]]) {
      data[[`button${i}`]] = {};
    }

    data[[`button${i}`]].text = text;
    onChange({
      data: data
    });
  };

  const changeUrl = (i, url) => {
    const data = value.data || {};
    if (!data[[`button${i}`]]) {
      data[[`button${i}`]] = {};
    }

    data[[`button${i}`]].url = url;
    onChange({
      data: data
    });
  };

  return <div>
    <div className="row mf-margin-bottom-20 mf-margin-top-10">
      {[...Array(value.data.buttons || 1)].map((_, i) => {
        return <div className="col-xs-12 col-md-4" key={i}>
          <div className="col-xs-12">
            <label>Type</label>
            <div className="form-group">
              <select
                className="form-control mf-margin-right-20"
                defaultValue={value.data?.[`button${i}`]?.type || 'primary'}
                onChange={(e) => changeButtonType(i, e.target.value)}
              >
                <option value="primary">Primær</option>
                <option value="secondary">Sekundær</option>
                <option value="tertiary">Tertiær</option>
              </select>
            </div>
          </div>
          <div className="col-xs-12">
            <label>Tekst</label>
            <div className="form-group">
              <input className="form-control" value={value.data?.[`button${i}`]?.text || ''} type="text" name="tekst" onChange={(e) => changeText(i, e.target.value)}/>
            </div>
          </div>
          <div className="col-xs-12">
            <label>URL</label>
            <div className="form-group">
              <input className="form-control" value={value.data?.[`button${i}`]?.url || ''} type="url" name="url" onChange={(e) => changeUrl(i, e.target.value)}/>
            </div>
          </div>
          <div className="col-xs-12">
            <div className="checkbox mf-margin-right-20"><label><input type="checkbox" value="" onChange={(e) => toggleBlank(i, e.target.checked)} name="fullwidth" defaultChecked={value.data?.[`button${i}`]?.blank} /> Åpnes i ny fane</label></div>
          </div>
          {value.data.buttons > 1 && <div className="col-xs-12 text-right">
            <button onClick={() => removeButton(i)} type="button" className="btn btn-danger btn-sm">Fjern knapp</button>
          </div>}
          {/*<pre>{JSON.stringify(value.data?.[`button${i}`], '', 4)}</pre>*/}
        </div>;
      })}
      {(value.data.buttons || 1) < 3 && <div className="col-xs-12 col-md-4 text-center">
        <button onClick={addButton} type="button" className="btn btn-default">+ Legg til knapp</button>
      </div>}
    </div>
    {/*<pre>{JSON.stringify(value.data, '', 4)}</pre>*/}
  </div>;
};

export default ButtonBlock;
